<template>
  <div>
    <!-- global block overlay while any spectreDialog is open -->
    <div v-if="openPopups.length" class="blocker"></div>

    <!-- render one overlay per opened spectreDialog (stackable) -->
    <div v-for="p in openPopups" :key="p.id" class="spectreDialog-ov" tabindex="0">
      <div class="spectreDialog" :style="p.style" :class="p.frameClass">
        <!-- Bild -->
        <img :src="p.image" @click="closePopup(p.id)"          
          @dragstart.prevent 
          @contextmenu.prevent 
          ondragstart="return false;" 
          alt="" />

        <!-- Close-Button -->
        <button
          class="close-button"
          :class="p.buttonPosition"
          @click="closePopup(p.id)"
        >
          ✖
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'SpectreAdsTrap',
  emits: ['done'],
  data() {
    return {
      timers: [],
      openPopups: [],
      availableImages: [], // Array für alle geladenen Bilder
      startedAt: null,
    };
  },
  async mounted() {
    await this.loadImages();
    this.start();
  },
  beforeUnmount() {
    this.stop();
  },
  methods: {
    async loadImages() {
      // Beispiel: Lade Bilder aus einem Ordner
      const imagePaths = [
        require('@/assets/Spectre/1.png'),
        require('@/assets/Spectre/2.png'),
        require('@/assets/Spectre/3.png'),
        require('@/assets/Spectre/4.png'),
        require('@/assets/Spectre/5.png'),
        require('@/assets/Spectre/6.png'),
        require('@/assets/Spectre/7.png'),
        require('@/assets/Spectre/8.png'),
        require('@/assets/Spectre/9.png'),
        require('@/assets/Spectre/10.png'),
        require('@/assets/Spectre/11.png'),
        require('@/assets/Spectre/12.png'),
        require('@/assets/Spectre/13.png'),
        require('@/assets/Spectre/14.png'),
        require('@/assets/Spectre/15.png'),
        require('@/assets/Spectre/16.png'),
        require('@/assets/Spectre/17.png'),
        require('@/assets/Spectre/18.png'),
        require('@/assets/Spectre/19.png'),
        require('@/assets/Spectre/20.png'),
        require('@/assets/Spectre/21.png'),
        require('@/assets/Spectre/22.png'),
        require('@/assets/Spectre/23.png'),
        require('@/assets/Spectre/24.png'),
        require('@/assets/Spectre/25.png'),
        require('@/assets/Spectre/26.png'),
        require('@/assets/Spectre/27.png'),
        require('@/assets/Spectre/28.png'),
        require('@/assets/Spectre/29.png'),
        require('@/assets/Spectre/30.png'),
        require('@/assets/Spectre/31.png'),
        require('@/assets/Spectre/32.png'),
        require('@/assets/Spectre/33.png'),
        require('@/assets/Spectre/34.png'),
        require('@/assets/Spectre/35.png'),
        require('@/assets/Spectre/36.png'),
        require('@/assets/Spectre/37.png'),
        require('@/assets/Spectre/38.png'),
        require('@/assets/Spectre/39.png'),
        require('@/assets/Spectre/40.png'),
        require('@/assets/Spectre/41.png'),
        require('@/assets/Spectre/42.png'),
        require('@/assets/Spectre/43.png'),
        require('@/assets/Spectre/44.png'),
        require('@/assets/Spectre/45.png'),
        require('@/assets/Spectre/46.png'),
        require('@/assets/Spectre/47.png'),
        require('@/assets/Spectre/48.png'),
        require('@/assets/Spectre/49.png'),
        require('@/assets/Spectre/50.png'),
        require('@/assets/Spectre/51.png'),
        require('@/assets/Spectre/52.png'),
        require('@/assets/Spectre/53.png'),
        require('@/assets/Spectre/54.png'),
        require('@/assets/Spectre/55.png'),
        require('@/assets/Spectre/56.png'),
        require('@/assets/Spectre/57.png'),
        require('@/assets/Spectre/58.png'),
        require('@/assets/Spectre/59.png'),
        require('@/assets/Spectre/60.png'),
        require('@/assets/Spectre/61.png'),
        require('@/assets/Spectre/62.png'),
        require('@/assets/Spectre/63.png'),
        require('@/assets/Spectre/64.png'),
        require('@/assets/Spectre/65.png'),
        require('@/assets/Spectre/66.png'),
        require('@/assets/Spectre/67.png'),
        require('@/assets/Spectre/68.png'),
        require('@/assets/Spectre/69.png'),
        require('@/assets/Spectre/70.png'),
        require('@/assets/Spectre/71.png'),
      ];
      this.availableImages = imagePaths;
    },
    start() {
      this.stop();
      this.startedAt = performance.now();

      const duration = 5000; // 5 Sekunden
      const totalPopups = 5;

      for (let i = 0; i < totalPopups; i++) {
        const delay = Math.random() * duration; // Zufälliger Zeitpunkt innerhalb von 5 Sekunden
        const image = this.getRandomImage(); // Zufälliges Bild
        const position = this.getRandomPosition(); // Zufällige Position

        const id = setTimeout(() => {
          this.open({
            image,
            x: position.x,
            y: position.y,
          });
        }, delay);

        this.timers.push(id);
      }
    },
    stop() {
      this.timers.forEach(t => clearTimeout(t));
      this.timers = [];
      this.startedAt = null;
    },
    getRandomImage() {
      const index = Math.floor(Math.random() * this.availableImages.length);
      return this.availableImages[index];
    },
    getRandomPosition() {
      const margin = 10; // Rand in Prozent, damit das Bild nicht am Rand klebt

      // Geschätzte Bildgröße prozentual dynamisch berechnen
      const imageWidth = (this.imageWidth || 0) / window.innerWidth * 100; // Breite als Anteil des Fensters
      const imageHeight = (this.imageHeight || 0) / window.innerHeight * 100;

      return {
        x: Math.random() * (100 - imageWidth - margin) + margin, // X-Position innerhalb des sicheren Bereichs
        y: Math.random() * (100 - imageHeight - margin) + margin, // Y-Position innerhalb des sicheren Bereichs
      };
    },
    getRandomFrameClass() {
      const frames = [
        'frame-blink-red',
        'frame-rainbow',
        'frame-blink-bw',
        'frame-pulse-yellow',
        'frame-green-blue',
        'frame-shaky-white',
        'frame-neon',
        'frame-glowing-red',
        'frame-radiant-gold',
      ];
      const index = Math.floor(Math.random() * frames.length);
      return frames[index];
    },
    getRandomButtonPosition() {
      const positions = ['top-left', 'top-right', 'bottom-left', 'bottom-right'];
      const index = Math.floor(Math.random() * positions.length);
      return positions[index];
    },
    open(entry) {
      const spectreDialog = {
        id: Date.now() + Math.random(),
        image: entry.image,
        style: {
          position: 'absolute',
          left: `${entry.x}%`,
          top: `${entry.y}%`,
          transform: 'translate(-50%, -50%)',
        },
        frameClass: this.getRandomFrameClass(), // Zufälliger Rahmenstil
        buttonPosition: this.getRandomButtonPosition(), // Zufällige Buttonposition
      };

      this.openPopups.push(spectreDialog);

      this.$nextTick(() => {
        const nodes = document.querySelectorAll('.spectreDialog-ov');
        if (nodes && nodes.length) nodes[nodes.length - 1].focus();
      });
    },
    closePopup(id) {
      const i = this.openPopups.findIndex(p => p.id === id);
      if (i !== -1) {
        this.openPopups.splice(i, 1);
      }

      if (this.openPopups.length === 0) {
        this.$emit('done');
      }
    },
  },
};
</script>

<style scoped>
.blocker {
  position: fixed;
  inset: 0;
  background: rgba(0,0,0,0.5);
  z-index: 30000;
  pointer-events: auto;
}
.spectreDialog-ov {
  position: fixed;
  inset: 0;
  z-index: 30010;
  pointer-events: none;
  display: flex;
  align-items: flex-start;
  justify-content: flex-start;
}
.spectreDialog {
  pointer-events: auto;
  border-radius: 6px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.5);
  max-width: 420px;
  max-height: 80vh;
}
.spectreDialog img {
  display: block;
  max-width: 100%; /* Bilder überschreiten nicht den verfügbaren Raum */
  max-height: 100%; /* Bilder überschreiten nicht die Bildschirmhöhe */
  object-fit: contain; /* Bild bleibt vollständig sichtbar */
  border-radius: 4px;
}

/* Basis-Styles für den Close-Button */
.close-button {
  position: absolute;
  width: 30px;
  height: 30px;
  border: none;
  border-radius: 50%;
  color: white;
  font-size: 16px;
  font-weight: bold;
  background-color: red;
  cursor: pointer;
  z-index: 1; /* Damit der Button vor dem Rahmen und Bild liegt */
  animation: button-animation 1.5s infinite;
}

/* Animation für den Button */
@keyframes button-animation {
  0%, 100% {
    transform: scale(1);
    box-shadow: 0 0 5px red;
  }
  50% {
    transform: scale(1.2);
    box-shadow: 0 0 10px rgba(255, 0, 0, 0.8);
  }
}

/* Positionen des Buttons */
.close-button.top-left {
  top: -15px;
  left: -15px;
}

.close-button.top-right {
  top: -15px;
  right: -15px;
}

.close-button.bottom-left {
  bottom: -15px;
  left: -15px;
}

.close-button.bottom-right {
  bottom: -15px;
  right: -15px;
}

/* 1. Rot blinkender Rahmen */
.frame-blink-red {
  position: relative; /* Erforderlich für das pseudoelement */
}

.frame-blink-red::before {
  content: '';
  position: absolute;
  inset: -5px; /* Rahmen platzieren */
  border: 5px solid red;
  animation: blink-red 1s infinite;
  pointer-events: none; /* Keine Interaktionen blockieren */
}

@keyframes blink-red {
  0%, 100% {
    opacity: 1;
  }
  50% {
    opacity: 0;
  }
}

/* 2. Regenbogenfarbiger Rahmen */
.frame-rainbow {
  border: 5px solid transparent;
  background-image: linear-gradient(45deg, red, orange, yellow, green, cyan, blue, violet);
  background-clip: border-box;
  animation: rainbow 3s infinite;
}

@keyframes rainbow {
  0% { filter: hue-rotate(0deg); }
  100% { filter: hue-rotate(360deg); }
}

/* 3. Schwarz-Weiß blinkender Rahmen */
.frame-blink-bw {
  border: 5px solid black;
  animation: blink-bw 1s infinite;
}

@keyframes blink-bw {
  0%, 100% {
    border-color: black;
  }
  50% {
    border-color: white;
  }
}

/* 4. Pulsierender gelber Rahmen */
.frame-pulse-yellow {
  position: relative; /* Notwendig für das ::before-Pseudo-Element */
}

.frame-pulse-yellow::before {
  content: '';
  position: absolute;
  inset: -5px; /* Rahmen um das Element herum platzieren */
  border: 5px solid yellow;
  animation: pulse-yellow 1.5s infinite;
  pointer-events: none; /* Interaktionen mit dem Rahmen verhindern */
}

@keyframes pulse-yellow {
  0%, 100% {
    transform: scale(1); /* Keine Größenänderung */
    opacity: 1; /* Volle Sichtbarkeit */
  }
  50% {
    transform: scale(1.1); /* Rahmen wächst leicht */
    opacity: 0.5; /* Leicht transparent */
  }
}

/* 5. Grün-blauer Wechselrahmen */
.frame-green-blue {
  border: 5px solid green;
  animation: green-blue 1s infinite;
}

@keyframes green-blue {
  0%, 100% {
    border-color: green;
  }
  50% {
    border-color: blue;
  }
}

.frame-shaky-white {
  position: relative; /* Grundlage für zitternden Effekt */
}

.frame-shaky-white::before {
  content: '';
  position: absolute;
  inset: -5px;
  border: 5px solid white;
  animation: shaky-white 0.2s infinite;
  pointer-events: none; /* Keine Interaktion blockiert */
}

@keyframes shaky-white {
  0% {
    transform: translate(0, 0);
  }
  25% {
    transform: translate(-2px, 2px);
  }
  50% {
    transform: translate(2px, -2px);
  }
  75% {
    transform: translate(-2px, -2px);
  }
  100% {
    transform: translate(0, 2px);
  }
}

.frame-neon {
  position: relative;
}

.frame-neon::before {
  content: '';
  position: absolute;
  inset: -5px;
  border: 5px solid #00ff00; /* Neon-Grün */
  box-shadow: 0 0 10px #00ff00, 0 0 20px #00ff00, 0 0 30px #00ff00;
  animation: neon-pulse 1.5s infinite;
  pointer-events: none;
}

@keyframes neon-pulse {
  0%, 100% {
    box-shadow: 0 0 10px #00ff00, 0 0 20px #00ff00, 0 0 30px #00ff00;
  }
  50% {
    box-shadow: 0 0 20px #00ff00, 0 0 40px #00ff00, 0 0 60px #00ff00;
  }
}

.frame-glowing-red {
  position: relative;
}

.frame-glowing-red::before {
  content: '';
  position: absolute;
  inset: -5px;
  border: 5px solid red;
  box-shadow: 0 0 10px rgba(255, 0, 0, 0.7);
  animation: glowing-red 2s infinite;
  pointer-events: none;
}

@keyframes glowing-red {
  0%, 100% {
    box-shadow: 0 0 10px rgba(255, 0, 0, 0.7);
    transform: scale(1);
  }
  50% {
    box-shadow: 0 0 50px rgba(255, 0, 0, 1);
    transform: scale(1.05);
  }
}

.frame-radiant-gold {
  position: relative; /* Notwendig für das Pseudo-Element */
}

.frame-radiant-gold::before {
  content: '';
  position: absolute;
  inset: -10px; /* Rahmen außerhalb des Bilds platzieren */
  border: 5px solid transparent;
  background: linear-gradient(90deg, rgba(255,223,0,1) 0%, rgba(255,165,0,1) 50%, rgba(255,223,0,1) 100%);
  background-size: 200% 200%;
  animation: radiant-gold 3s linear infinite;
  pointer-events: none; /* Keine Überlappung von Interaktionen */
  z-index: -1; /* Rahmen unter das Bild legen */
  border-radius: 6px; /* Gleiche Rundungen wie das Bild verwenden */
}

@keyframes radiant-gold {
  0% {
    background-position: 0% 50%;
  }
  100% {
    background-position: 100% 50%;
  }
}
</style>